export enum OrganizationType {
  /** Aktiebolag */
  LLC = "LLC",
  /** Ekonomisk förening */
  CommercialAssociation = "CommercialAssociation",
  /** Ideella föreningar */
  NonprofitAssosiation = "NonprofitAssosiation",
  /** Kommun */
  Commune = "Commune",
  /** Landsting aka Region */
  County = "County",
  /** Norge */
  Norway = "Norway",
  /** Statlig enhet */
  StateUnit = "StateUnit",
  /** Kommanditbolag */
  Partnership = "Partnership"
}
